import React, { useState, useEffect } from "react";
import Sidebar from "./sidebar";
import Navbar from "./nav1";
import { Outlet } from "react-router-dom";
import "./homepage.css";

const MainPage = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [active, setActive] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 480) setIsOpen(false);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="body">

      {/* NAVBAR */}
      <div
        className="navbar-wrapper"
        style={{
          marginLeft: isOpen ? "240px" : "75px",
          width: `calc(100% - ${isOpen ? 240 : 75}px)`,
          transition: "0.3s ease"
        }}
      >
        <Navbar />
      </div>

      {/* SIDEBAR ALWAYS FIXED */}
      <Sidebar
        active={active}
        setActive={setActive}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />

      {/* PAGE CONTENT (ONLY THIS CHANGES) */}
      <div
        className="content"
        style={{
          marginLeft: isOpen ? "240px" : "75px",
          padding: "60px",
          transition: "0.3s"
        }}
      >
        <Outlet />   {/* ← NEW PAGE loads here */}
      </div>

    </div>
  );
};

export default MainPage;
